import { MessageCirclePlus, MessagesSquare } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';
import { useHasPermission } from '@/entities/profile';
import { IconButton } from '@/shared/ui';
import { useCopilotPanelActions } from '@/widgets/MainLayout/model/hooks/useCopilotPanelActions';

const buttonClassName = cn('size-8 min-h-7', 'hover:bg-sidebar-accent hover:text-sidebar-accent-foreground');

/**
 * Кнопки действий ИИ-агента наверху свёрнутой до иконок панели навигации:
 * в этом состоянии панель одна, отдельная колонка PanelsBar не рендерится.
 */
export const CollapsedAiActions: FC = () => {
  const { t } = useTranslation(['aiAgent']);
  const canUseAiAgent = useHasPermission('USE_AI_AGENT');
  const { handleCreateNewChat, handleShowChatList } = useCopilotPanelActions();

  if (!canUseAiAgent) {
    return null;
  }

  return (
    <div className={'flex flex-col items-center gap-2 px-2 py-2 border-b border-sidebar-border'}>
      <IconButton
        icon={<MessageCirclePlus className="h-5 w-5" />}
        size="icon"
        className={buttonClassName}
        label={t('aiAgent:newChat')}
        onClick={handleCreateNewChat}
      />
      <IconButton
        icon={<MessagesSquare className="h-5 w-5" />}
        size="icon"
        className={buttonClassName}
        label={t('aiAgent:chatList')}
        onClick={handleShowChatList}
      />
    </div>
  );
};
